module.exports = __webpack_public_path__ + "static/img-life-e51dd313c310a05bd82f446299dd76a1.jpg";